import React, { useEffect, useState } from "react";
import { apis, patch } from "../../Utils/axios";
import { Button, Form, Input, Modal, Select, Toast } from "..";
import { COUNTRIES } from "../../Utils/constants";
import { TbIdBadge } from "react-icons/tb";

function EditNationalId({ reload, identification = {}, userId, guestId }) {
	const [Loading, setLoading] = useState(false);
	const { nationality, nationalIdNumber } = identification || {};
	const [EditPassport, setEditPassport] = useState();
	const [Values, setValues] = useState({
		nationality: nationality || "",
		nationalIdNumber: nationalIdNumber || "",
	});

	useEffect(() => {
		setValues({
			nationality: nationality || "",
			nationalIdNumber: nationalIdNumber || "",
		});
	}, [nationality, nationalIdNumber]);

	const onUpdate = () => {
		if (!Values.nationalIdNumber || !Values.nationality) {
			return Toast.error("Please fill all the fields");
		}
		setLoading(true);
		patch(
			userId ? apis.updateUserIdentification(userId) : guestId ? apis.updateGuestIdentification(guestId) : apis.updateMyIdentification,
			{
				...Values,
				...(guestId ? { guestId } : { userId }),
			},
			(r, e) => {
				setLoading(false);
				if (r) {
					reload(Values);
					Toast.success(`Identification Updated`);
				} else if (e) {
					Toast.handleError(e);
				}
			}
		);
	};

	const newChanges = nationalIdNumber !== Values.nationalIdNumber || nationality !== Values.nationality;

	return (
		<>
			<Button onClick={() => setEditPassport(true)} variant="outlined" className="btn-xs">
				<TbIdBadge className="mr-2" />
				{nationalIdNumber || "Add National ID"}
			</Button>
			<Modal open={EditPassport} onClose={() => setEditPassport()} contentClass="w-[95vw] max-w-[42rem]">
				<div className="p-4 sm:p-6 md:p-8">
					<h1 className="text-xl sm:text-2xl font-bold pr-10">National ID</h1>
					<Form onSubmit={onUpdate} className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-4">
						<Input required value={Values.nationalIdNumber} label="National ID" placeholder="National ID" onChange={(nationalIdNumber) => setValues((prev) => ({ ...prev, nationalIdNumber }))} />
						<Select
							btnClass="w-full"
							options={COUNTRIES}
							required
							selected={{ value: Values.nationality, label: Values.nationality }}
							label="Nationality"
							placeholder="Nationality"
							onChange={(nationality) => setValues((prev) => ({ ...prev, nationality: nationality.value }))}
						/>
						{newChanges && (
							<Button loading={Loading} type="submit" className="w-full sm:col-span-2">
								Save
							</Button>
						)}
					</Form>
				</div>
			</Modal>
		</>
	);
}

export default EditNationalId;
